import { Box, Flex, Skeleton, Text } from '@chakra-ui/react';
import Divider from '../../../others/Divider';

interface PageHeaderProps {
  loading?: boolean;
  title: string | React.ReactNode;
  subtitle?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ loading, title, subtitle, children }) => {
  const hasSubtitle = subtitle && subtitle !== '';
  const subtitlePlaceholder = <Box h="27px" w="50px" />;

  const topPlaceholder = (
    <div>
      <Skeleton width={200} height="32px" />
      <Skeleton width={120} height="22px" mt="4px" />
    </div>
  );

  const titleAndSubtitle = (
    <div>
      {typeof title === 'string' ? (
        <Text as="h5" fontSize={24} fontWeight="500">
          {title}
        </Text>
      ) : (
        title
      )}
      {hasSubtitle ? (
        <Text color="gray.400" mt="4px" ml="2px" fontSize={14}>
          {subtitle}
        </Text>
      ) : (
        subtitlePlaceholder
      )}
    </div>
  );

  return (
    <Flex direction="column">
      <Flex justify="space-between" mb="16px">
        <div>{loading ? topPlaceholder : titleAndSubtitle}</div>

        <Box textAlign="right">{children}</Box>
      </Flex>

      <Divider />
    </Flex>
  );
};

export default PageHeader;
